export const FREE_TIER_FEATURES = [
  'Up to 25 code contributors',
  'Limited to 5 projects',
  'Limited to 1 release group',
  'Limited 1 user',
  'Default Security Policy',
  'Default Quality Policy',
  'Limited Package Health Signals',
  '5 policy-scan depth levels',
  'All dependency depth levels',
  'C/C++ license scanning',
];

export const BUSINESS_TIER_FEATURES = [
  'Up to 5-25 code contributors',
  'Limited to 10 projects',
  'Limited to 1 release group',
  'Default + Custom Security Policies',
  'Default + Custom Quality Policies',
  'All Package Health Signals',
  'Users + Teams',
  'All policy-scan depth levels',
  'All dependency depth levels',
  'C/C++ license scanning',
];

export const ENTERPRISE_TIER_FEATURES = [
  '25+ code contributors',
  'Unlimited projects',
  'Limited to 1 release group',
  'Default + Custom Security Policies',
  'Default + Custom Quality Policies',
  'All policy-scan depth levels',
  'All dependency depth levels',
  'C/C++ license scanning',
  'Premium dedicated Slack channel',
  'On-premises deployment',
  'Users + Teams w/ RBAC',
  'Single Sign-on (SSO)',
  'Audit Logs',
];
